import React, { Component } from 'react';
import moment from 'moment';
import Table from './common/table';

const $ = require('jquery');
$.DataTable = require('datatables.net');

class BuyBitcoinsTable extends Component {
  columns = [
    {
      path: 'user',
      label: 'By:',
      content: (payment) => payment.user,
    },
    { path: 'wallet_address', label: 'Wallet:' },
    { path: 'amount', label: 'Amount (USD):' },
    { path: 'nairaEquivalence', label: 'Amount (₦):' },
    // { path: 'trade_reference', label: 'Trade Ref:' },
    { path: 'payment_reference', label: 'Payment Ref:' },
    { path: 'payment_status', label: 'Payment Status' },
    { path: 'gateway_response', label: 'Paystack Response' },
    {
      path: 'transaction_date',
      label: 'Txn Date',
      content: (payment) =>
        moment(payment.created_at).startOf('day').format('LL'),
    },
  ];

  componentDidMount() {
    $(document).ready(function () {
      $('#dataTable').DataTable();
    });
  }

  render() {
    const { payments, message } = this.props;
    return <Table columns={this.columns} data={payments} message={message} />;
  }
}

export default BuyBitcoinsTable;
